import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { acceptAllCookies, hasAnsweredConsent, rejectNonEssentialCookies } from '../utils/cookieConsent';
import { applyConsentState, initAnalytics } from '../utils/analytics';
import CookiePreferencesDialog from './CookiePreferencesDialog';
import './CookieConsentBanner.css';

const CookieConsentBanner = () => {
  const { t } = useTranslation('common');
  const [visible, setVisible] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);

  useEffect(() => {
    initAnalytics();
    setVisible(!hasAnsweredConsent());
  }, []);

  const handleAcceptAll = () => {
    acceptAllCookies();
    applyConsentState();
    setVisible(false);
  };

  const handleReject = () => {
    rejectNonEssentialCookies();
    applyConsentState();
    setVisible(false);
  };

  const handlePreferencesSaved = () => {
    setShowPreferences(false);
    setVisible(false);
  };

  return (
    <>
      {visible && (
        <div className="cookie-consent-banner" role="dialog" aria-label={t('cookieConsentLabel')}>
          <div className="cookie-consent-banner__content">
            <p className="cookie-consent-banner__text">{t('cookieConsentText')}</p>
            <div className="cookie-consent-banner__actions">
              <button type="button" className="btn btn-secondary" onClick={handleReject}>
                {t('rejectNonEssential')}
              </button>
              <button type="button" className="btn btn-secondary" onClick={() => setShowPreferences(true)}>
                {t('managePreferences')}
              </button>
              <button type="button" className="btn btn-primary" onClick={handleAcceptAll}>
                {t('acceptAll')}
              </button>
            </div>
          </div>
        </div>
      )}
      <CookiePreferencesDialog
        open={showPreferences}
        onClose={() => setShowPreferences(false)}
        onSaved={handlePreferencesSaved}
      />
    </>
  );
};

export default CookieConsentBanner;
